import React, { useState } from 'react';
import { TProductFeatureComponentProps } from '../types/productFeatureComponent.types';
import ComponentDetails from './componentDetails';
import { ProductFeatureModel } from '../models/productFeatureComponent.model';
import Icon from '../../icon';
import FeatureHeader from './featureHeader';

const MobileSeriesDetails = (props: TProductFeatureComponentProps): JSX.Element => {
  const model = new ProductFeatureModel(props);
  const isEEActive = props?.sitecoreContext?.pageEditing;
  const [collapsedTabs, setCollapsedTabs] = useState(model.innerComponents?.map(({ id }) => id));

  const toggleTab = (tabId: number): void => {
    if (collapsedTabs.includes(tabId)) {
      setCollapsedTabs(collapsedTabs.filter((tab) => tab !== tabId));
    } else {
      setCollapsedTabs([...collapsedTabs, tabId]);
    }
  };

  return (
    <>
      <section className="product-feature product-white-spacer">
        <div className="product-feature__container">
          <FeatureHeader
            title={model?.title}
            isEEActive={isEEActive}
            titleDictionaryKeyFeature={props.titleDictionaryKeyFeature}
            rendering={props.rendering}
          />
          <ul className="product-feature__tabs">
            {model?.innerComponents?.map((component, index) => {
              const isCollapsed = collapsedTabs.includes(component.id);
              return (
                <li className={`product-feature__tab ${!isCollapsed ? 'product-feature__tab--selected' : ''}`} key={component?.id}>
                  <button
                    className="product-feature__tab-button"
                    onClick={(): void => {
                      toggleTab(component.id);
                    }}
                  >
                    <h3>{component.eyebrow}</h3>
                    <Icon
                      size={24}
                      iconName={'arrow-chevron-down'}
                      extraClassName={isCollapsed ? 'product-feature__tab-button--close' : 'product-feature__tab-button--open'}
                    />
                  </button>
                  <ComponentDetails
                    showImageOverlay={props?.showImageOverlay}
                    component={model?.innerComponents?.[index]}
                    isSeries={props?.isSeries}
                    cardCTAVisibleEvent={props?.cardCTAVisibleEvent}
                    className={`${isCollapsed ? 'product-feature__component--hidden' : 'product-feature__component--show'}`}
                    isCollapsed={isCollapsed}
                    isMobile
                  />
                </li>
              );
            })}
          </ul>
        </div>
      </section>
    </>
  );
};

export default MobileSeriesDetails;
